<div class="ui-button-toggle-holder">
  <ng-content></ng-content>
  <div class="ui-button-toggle">
    <input #changeEvent type="checkbox" [checked]="checked" (change)="onChangeEvent(changeEvent.checked)" />
    <div class="toggle">
      <div class="circle">
        <div class="mark">
          <div class="line1"></div>
          <div class="line2"></div>
        </div>
      </div>
    </div>
  </div>
</div>
